
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoganpatipule() {



    const cardData =
    {
        keyword: 'Pune to Ganpatipule Taxi',
        heading: 'Platinum24 Cabs: Pune to Ganpatipule Taxi',
        headingDescription: ' Platinum24 Cabs provides comfortable Pune to Ganpatipule Taxi services, perfect for family vacations, spiritual visits, and coastal getaways. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth ride through the scenic Konkan routes, with ample space and air-conditioned comfort. With professional drivers experienced on long-distance coastal roads, we guarantee safe, timely, and enjoyable travel. Whether you’re visiting the famous Ganpatipule Temple, relaxing on pristine beaches, or exploring nearby Konkan attractions, Platinum24 Cabs offers affordable fares, flexible bookings, and a stress-free journey from Pune to Ganpatipule.',

        top: 'Top Places to Visit in Ganpatipule with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is a pristine stretch of golden sand and clear waters, making it one of the cleanest beaches in Maharashtra. The beach is peaceful, less crowded, and perfect for families. Water sports like jet skiing, parasailing, and banana boat rides are available. Sunsets here are mesmerizing, painting the sky in shades of orange and red. Beach shacks serve fresh Konkani seafood. Ganpatipule Beach is the town’s natural paradise of beauty and relaxation."
  },
  {
    "title": "Swayambhu Ganpati Temple",
    "description": "The Swayambhu Ganpati Temple, over 400 years old, houses a self-manifested idol of Lord Ganesha. The temple is located right on the beach, adding a serene coastal charm. Devotees believe that prayers here remove obstacles and bring prosperity. Festivals like Ganesh Chaturthi and Magh Shuddh Chaturthi are celebrated with grandeur. The temple’s aura blends spirituality with nature. It is Ganpatipule’s divine and cultural heart."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort, located about 20 km from Ganpatipule, stands majestically on a cliff overlooking the Arabian Sea. Built in the 16th century, it served as a strategic defense fort for the Marathas. The fort offers panoramic views of Jaigad Creek and the sea. Inside, one can explore old wells, temples, and ruins. Its rustic charm attracts history buffs and photographers. Jaigad Fort is Ganpatipule’s proud heritage landmark."
  },
  {
    "title": "Prachin Konkan Museum",
    "description": "Prachin Konkan Museum is an open-air museum that showcases the lifestyle, culture, and traditions of the Konkan region. Life-sized models depict rural life, traditional homes, and occupations. Visitors learn about Konkani art, festivals, and history. It is educational and entertaining for both children and adults. Surrounded by greenery, it creates an authentic village vibe. The museum is Ganpatipule’s cultural window into Konkan’s past."
  },
  {
    "title": "Aare-Ware Beaches",
    "description": "Aare-Ware are twin beaches located a few kilometers from Ganpatipule. The beaches are untouched and offer stunning sea views along a winding coastal road. Travelers enjoy peaceful walks, photography, and solitude here. Unlike crowded beaches, Aare-Ware remain quiet and serene. Sunsets are especially enchanting with panoramic views of the Arabian Sea. Aare-Ware are Ganpatipule’s hidden gems of natural beauty."
  },
  {
    "title": "Malgund",
    "description": "Malgund, a small village near Ganpatipule, is the birthplace of the famous Marathi poet Kavi Keshavsut. The village houses a memorial dedicated to him, which is now a museum. It showcases his works and contributions to Marathi literature. Malgund’s coastal charm and cultural significance attract literature enthusiasts. It also offers homestays for tourists seeking local experiences. Malgund is Ganpatipule’s poetic and cultural retreat."
  },
  {
    "title": "Jaigad Lighthouse",
    "description": "Located near Jaigad Fort, the Jaigad Lighthouse is a must-visit for panoramic sea views. Built during the British era, it still guides ships along the Konkan coast. Visitors can climb to the top for breathtaking vistas of the Arabian Sea and surrounding landscape. The lighthouse stands as a symbol of maritime heritage. It is less crowded, making it peaceful for exploration. Jaigad Lighthouse is Ganpatipule’s coastal heritage point."
  },
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri, located 25 km from Ganpatipule, is famous for its Alphonso mangoes and heritage attractions. Key spots include Ratnadurg Fort, Thibaw Palace, and Mandavi Beach. The city also has temples and museums showcasing Konkan’s culture. Shoppers enjoy buying local products like mango pulp and handicrafts. Ratnagiri blends history with natural beauty. It is Ganpatipule’s nearby cultural and culinary hub."
  },
  {
    "title": "Velneshwar Beach & Temple",
    "description": "Velneshwar Beach, about 40 km from Ganpatipule, is a serene destination known for its black sand beach and Shiva temple. The beach is clean, safe for swimming, and ideal for picnics. The ancient temple adds a spiritual charm to the coastal setting. It is less commercialized, perfect for those seeking solitude. Coconut groves and gentle waves make it scenic. Velneshwar is Ganpatipule’s spiritual seaside retreat."
  },
  {
    "title": "Hedvi Dashbhuja Ganesh Temple",
    "description": "Hedvi, located near Ganpatipule, is home to the rare Dashbhuja Ganesh Temple, where Lord Ganesha is depicted with ten arms. The temple is over 250 years old and holds immense religious significance. Nearby is the scenic Hedvi Beach and the natural rock formation called Bahman Ghal. Pilgrims and tourists combine spiritual visits with coastal beauty here. Hedvi is Ganpatipule’s unique blend of devotion and nature."
  }
],



   "services": [
    {
      "name": "Pune to Ganpatipule Cab",
      "description": "Travel from Pune to Ganpatipule in a comfortable and reliable cab with professional drivers and well-maintained vehicles. Ideal for solo travelers, couples, families, and groups planning a beach vacation or religious pilgrimage. Our cab service ensures a hassle-free journey with clean interiors, sanitized vehicles, and timely pickups. We provide door-to-door cab service with flexible pickup times and a choice of vehicle types, including hatchbacks, sedans, and SUVs."
    },
    {
      "name": "Ganpatipule Taxi Service Pune",
      "description": "Explore Ganpatipule with professional taxi services originating from Pune. Our fleet is equipped with modern amenities like air conditioning, real-time tracking, and trained chauffeurs who ensure a safe and scenic drive. Ideal for vacationers, spiritual tourists, and business travelers, our service includes local sightseeing, beach visits, and return rides. We also offer 24/7 support and options for single-day or multi-day packages based on your travel plans."
    },
    {
      "name": "Pune to Ganpatipule Taxi Booking",
      "description": "Instant and easy taxi booking from Pune to Ganpatipule via online or phone reservations. Choose from a wide range of vehicles including budget hatchbacks, comfortable sedans, and spacious SUVs. Booking includes live updates, transparent pricing, and flexible rescheduling options. Whether planning a last-minute trip or scheduling a weekend getaway, our system makes booking a cab effortless and reliable."
    },
    {
      "name": "Taxi from Pune to Ganpatipule",
      "description": "Book a taxi from Pune to Ganpatipule for a convenient and scenic road trip to the coastal town. All taxis are GPS-enabled, regularly serviced, and driven by experienced chauffeurs familiar with the route and rest points. Ideal for families, couples, or groups heading to the beach, temple, or nearby attractions. We offer one-way, round-trip, and same-day return taxi options for full flexibility."
    },
    {
      "name": "Ganpatipule Cab Rental Pune",
      "description": "Affordable and flexible cab rental options for your trip from Pune to Ganpatipule. Rent a cab by the hour, day, or for the full trip. Suitable for personal, family, or group travel. Our fleet includes economy to luxury vehicles and we offer chauffeur-driven or self-drive rental choices. Cab rental includes insurance, fuel packages, and customer support throughout the journey."
    },
    {
      "name": "Pune to Ganpatipule Taxi Fare",
      "description": "Get transparent and budget-friendly taxi fare estimates for your Pune to Ganpatipule journey. Our fare includes vehicle type, tolls, driver allowance, fuel, and applicable taxes. No hidden charges—fare breakdown is shared before booking. Whether you're choosing an economy car or a premium SUV, you’ll receive a competitive and fixed price with full cost clarity."
    },
    {
      "name": "Cab Service Pune to Ganpatipule",
      "description": "Dedicated cab services from Pune to Ganpatipule that focus on safety, comfort, and customer satisfaction. All vehicles are thoroughly cleaned, AC-enabled, and operated by verified drivers. Suitable for tourists heading for a relaxing beach vacation, spiritual seekers visiting the Ganpati temple, or families on holiday. Enjoy multiple vehicle choices, instant confirmation, and 24x7 helpline support."
    },
    {
      "name": "Pune Ganpatipule Private Taxi",
      "description": "Hire a private taxi from Pune to Ganpatipule for a personalized and secure travel experience. Ideal for those who prefer non-shared transport and a direct route. Choose your pickup time, route preferences, and stopovers. Our private taxis offer air conditioning, entertainment options, and courteous drivers who make your long-distance journey comfortable and safe."
    },
    {
      "name": "Ganpatipule Taxi Charges Pune",
      "description": "Review detailed taxi charges from Pune to Ganpatipule with no surprise costs. Our pricing includes all mandatory charges like fuel, tolls, and driver fees. Charges vary by vehicle category—hatchback, sedan, SUV, or luxury. We offer the best deals and discounts on early bookings and return trips. Custom quotes are available for group bookings and multi-day trips."
    },
    {
      "name": "Pune to Ganpatipule Car Hire",
      "description": "Hire a car from Pune to Ganpatipule for a flexible and independent travel experience. Choose between self-drive and chauffeur-driven options. We offer hourly, daily, and per-kilometer rental plans. Cars are regularly serviced and available in both budget and premium segments. Perfect for those who want to drive at their own pace or enjoy a relaxed journey with a professional driver."
    },
    {
      "name": "Ganpatipule Taxi Packages Pune",
      "description": "Book all-inclusive taxi packages from Pune to Ganpatipule that cover fuel, driver, tolls, and optional sightseeing. Packages are designed for individuals, couples, families, and group travelers with options for one-way, round-trip, and multi-day stays. Customizable as per your schedule and budget, our packages ensure a well-planned and economical travel experience."
    },
    {
      "name": "Ganpatipule Cab for Pilgrimage Pune",
      "description": "Travel from Pune to Ganpatipule for religious or spiritual purposes with our specialized pilgrimage cab services. Our drivers understand the importance of the trip and offer respectful and timely transport to and from the famous Ganpatipule temple and other nearby religious sites. Cabs are clean, comfortable, and available for solo travelers and large groups alike."
    },
    {
      "name": "Pune to Ganpatipule Outstation Taxi",
      "description": "Plan an outstation trip from Pune to Ganpatipule with our reliable taxi service. Our outstation taxis come equipped for long-distance journeys with amenities like cushioned seats, ample luggage space, and music systems. Ideal for family vacations, weekend getaways, or group travel. Book for one-way, round trip, or a multi-stop journey and enjoy professional service throughout."
    },
    {
      "name": "Ganpatipule Taxi for Family Trips Pune",
      "description": "Take your family from Pune to Ganpatipule in a spacious and safe taxi. Our family trip cabs include large sedans and SUVs with extra legroom and child-safe features. Drivers are courteous, experienced, and trained to ensure comfort for all age groups. Luggage assistance, rest stops, and custom route options are available for a stress-free family holiday experience."
    },
    {
      "name": "Pune to Ganpatipule One Way Cab",
      "description": "Book a one-way cab from Pune to Ganpatipule and pay only for the journey you take. Avoid return charges and enjoy a private ride at an economical price. Perfect for travelers with fixed plans or staying longer at their destination. Vehicles include economy to premium models with flexible departure timings and doorstep pickups."
    }
  ],
  "tableData": [
    ["Pune to Ganpatipule Cab", "Ganpatipule Taxi Service Pune"],
    ["Pune to Ganpatipule Taxi Booking", "Taxi from Pune to Ganpatipule"],
    ["Ganpatipule Cab Rental Pune", "Pune to Ganpatipule Taxi Fare"],
    ["Cab Service Pune to Ganpatipule", "Pune Ganpatipule Private Taxi"],
    ["Ganpatipule Taxi Charges Pune", "Pune to Ganpatipule Car Hire"],
    ["Ganpatipule Taxi Packages Pune", "Ganpatipule Cab for Pilgrimage Pune"],
    ["Pune to Ganpatipule Outstation Taxi", "Ganpatipule Taxi for Family Trips Pune"],
    ["Pune to Ganpatipule One Way Cab", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Trusted Pune to Ganpatipule Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable taxi rides from Pune to Ganpatipule for a hassle-free journey."
    },
    {
      "WhyChooseheading": "Punctual Pickups to Ensure Timely Arrival",
      "WhyChoosedescription": "Our drivers guarantee on-time pickups so you can enjoy your trip without any stress."
    },
    {
      "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned taxis designed for long-distance comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Ganpatipule Routes",
      "WhyChoosedescription": "Our professional drivers know the best routes to ensure a safe and smooth ride."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
      "WhyChoosedescription": "Benefit from upfront pricing that includes fuel, tolls, and driver allowances for peace of mind."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Packages",
      "WhyChoosedescription": "Customize your booking with options suitable for your travel plans between Pune and Ganpatipule."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our support team is available around the clock to assist you with bookings and inquiries."
    },
    {
      "WhyChooseheading": "Variety of Vehicle Options to Fit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, or SUVs based on your group size and luggage requirements."
    }
  ]






















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services from Pune to Ganpatipule?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable taxi services for travel between Pune and Ganpatipule.',
    },
    {
        question: 'How can I book a taxi from Pune to Ganpatipule with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Ganpatipule taxi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ganpatipule trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Ganpatipule?',
        answer: 'Yes, all our drivers are professional, experienced, and familiar with the Pune to Ganpatipule route to ensure a safe journey.',
    },
    {
        question: 'Can I book a round trip taxi from Pune to Ganpatipule?',
        answer: 'Absolutely! We provide round-trip taxi services with flexible scheduling to suit your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Ganpatipule taxi services?',
        answer: 'The fare covers vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Ganpatipule rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Ganpatipule route.',
    },
    {
        question: 'Are safety measures in place for Pune to Ganpatipule taxi rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure your protection.',
    },
    {
        question: 'Is it possible to hire a taxi for multiple days for Pune to Ganpatipule travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Ganpatipule?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Ganpatipule routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Deshmukh',
        feedback: 'The Pune to Ganpatipule taxi service by Platinum24 Cabs was punctual and comfortable. The driver was very courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Booking a taxi to Ganpatipule was easy and hassle-free. The vehicle was clean and the service excellent.',
        rating: 5,
    },
];





































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToGanpatipuleTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ganpatipule Taxi",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-ganpatipule-taxi.jpg",
  "description": "Book trusted Pune to Ganpatipule taxi service for family trips, pilgrimage, and outstation travel. Affordable and reliable private cabs with verified drivers at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-ganpatipule-taxi"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Ganpatipule Taxi | Reliable Private Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book trusted Pune to Ganpatipule taxi service for family trips, pilgrimage, and outstation travel. Affordable and reliable private cabs with verified drivers at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Pune to Ganpatipule Cab, Ganpatipule Taxi Service Pune, Pune to Ganpatipule Taxi Booking, Taxi from Pune to Ganpatipule, Ganpatipule Cab Rental Pune, Pune to Ganpatipule Taxi Fare, Cab Service Pune to Ganpatipule, Pune Ganpatipule Private Taxi, Ganpatipule Taxi Charges Pune, Pune to Ganpatipule Car Hire, Ganpatipule Taxi Packages Pune, Ganpatipule Cab for Pilgrimage Pune, Pune to Ganpatipule Outstation Taxi, Ganpatipule Taxi for Family Trips Pune, Pune to Ganpatipule One Way Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGanpatipuleTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoganpatipule;